import { MapPin, Navigation } from "lucide-react";

const NEIGHBORHOOD_COORDS = {
  Downtown: [45.5215, -122.6786],
  Southeast: [45.5152, -122.6534],
  Northwest: [45.5372, -122.7085],
  Northeast: [45.5595, -122.6403],
  Beaverton: [45.4871, -122.8037],
  Portland: [45.5152, -122.6784],
  Online: [45.5152, -122.6784],
};

export const VenueMap = ({ event }) => {
  const [lat, lon] = NEIGHBORHOOD_COORDS[event.neighborhood] || NEIGHBORHOOD_COORDS.Portland;
  const d = 0.012;
  const bbox = `${lon - d},${lat - d / 2},${lon + d},${lat + d / 2}`;
  const embed = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lon}`;
  const query = encodeURIComponent(event.address || `${event.venue_name}, Portland OR`);

  if (event.neighborhood === "Online") {
    return (
      <div className="mt-4 rounded-2xl border border-neutral-200 bg-neutral-50 p-6 text-sm text-neutral-600" data-testid="venue-online">
        This one is online — the organizer shares the link before the session.
      </div>
    );
  }

  return (
    <div className="mt-4" data-testid="venue-map">
      <div className="overflow-hidden rounded-2xl border border-neutral-200">
        <iframe
          title="Venue map"
          src={embed}
          className="h-64 w-full"
          loading="lazy"
          style={{ border: 0 }}
        />
      </div>
      <div className="mt-3 flex flex-wrap gap-3">
        <a
          data-testid="directions-link"
          href={`https://www.openstreetmap.org/directions?from=&to=${lat}%2C${lon}`}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-1.5 rounded-full bg-neutral-900 px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-neutral-700"
        >
          <Navigation className="h-4 w-4" /> Walking directions
        </a>
        <a
          data-testid="search-venue-link"
          href={`https://www.openstreetmap.org/search?query=${query}`}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-1.5 rounded-full border border-neutral-300 px-4 py-2 text-sm font-semibold text-neutral-800 transition-colors duration-200 hover:bg-neutral-50"
        >
          <MapPin className="h-4 w-4" /> Look up venue
        </a>
      </div>
    </div>
  );
};
